
import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ThemeToggle from "./ThemeToggle";
import { useTheme } from "./ThemeProvider";
const HeaderOne = ({ setOpenGetDemoModal }) => {
  const { t, i18n } = useTranslation();
  const [active, setActive] = useState(false);
  const [scroll, setScroll] = useState(false);
  const { isDarkMode } = useTheme()
  const assetBase = process.env.PUBLIC_URL || "";

  const navigate = useNavigate();
  const location = useLocation();
  const getLocalizedPath = (lang, path = "") => {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return normalizedPath === "/" ? `/${lang}` : `/${lang}${normalizedPath}`;
  };

  useEffect(() => {
    var offCanvasNav = document.getElementById("offcanvas-navigation");
    var menuExpand = offCanvasNav.querySelectorAll(
      ".has-submenu > .nav-menu__link"
    );
    var numMenuExpand = menuExpand.length;

    function sideMenuExpand() {
      if (this.parentElement.classList.contains("active") === true) {
        this.parentElement.classList.remove("active");
      } else {
        for (let i = 0; i < numMenuExpand; i++) {
          menuExpand[i].parentElement.classList.remove("active");
        }
        this.parentElement.classList.add("active");
      }
    }

    for (let i = 0; i < numMenuExpand; i++) {
      menuExpand[i].addEventListener("click", sideMenuExpand);
    }

  }, []);


  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const mobileMenu = () => {
    setActive(!active);
  };

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);

    const pathParts = location.pathname.split("/").filter(Boolean);
    const hasLocalePrefix = pathParts[0] === "en" || pathParts[0] === "hy";
    const routeParts = hasLocalePrefix ? pathParts.slice(1) : pathParts;
    const routePath = routeParts.length ? `/${routeParts.join("/")}` : "/";

    navigate(getLocalizedPath(lang, routePath) + location.search, { replace: true });
  };
  const moveHomeClick = (event, href) => {
    event.preventDefault();
    const homePath = getLocalizedPath(i18n.language, "/");
    if (location.pathname !== homePath) {
      navigate(homePath, { replace: false });
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.querySelector(href);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const closeMobileMenu = () => {
    setActive(false);
  };

  return (
    <>
      <div className="overlay"></div>
      <div className={`side-overlay ${active && "show"}`}></div>
      {/* ==================== Header Start Here ==================== */}
      <header className={`header ${scroll ? "fixed-header" : ""} `}>
        <div className="container container-full">
          <nav className="header-inner flx-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to={getLocalizedPath(i18n.language, "/")} className="link" >
                <img src={`${assetBase}/assets/images/logo/${isDarkMode ? "tamias-logo_dark" : "tamias-logo_light"}.png`} alt="Logo" />
              </Link>
            </div>
            {/* Logo End  */}
            {/* Menu Start  */}
            <div className="header-menu d-lg-block d-none">
              <ul className="nav-menu flx-align">
                <li className="nav-menu__item">
                  <a className="nav-menu__link" href="#about" onClick={(event) => moveHomeClick(event, "#about")}>{t('about')}</a>
                </li>
                <li className="nav-menu__item">
                  <a className="nav-menu__link" href="#solutions" onClick={(event) => moveHomeClick(event, "#solutions")}>{t('solutions')}</a>
                </li>

                <li className="nav-menu__item">
                  {/* has-submenu */}
                  <NavLink to={getLocalizedPath(i18n.language, "/blog")} className="nav-menu__link">
                    {t('blog')}
                  </NavLink>
                </li>
                <li className="nav-menu__item">
                  <NavLink to={getLocalizedPath(i18n.language, "/contact")} className="nav-menu__link">
                    {t('contact')}
                  </NavLink>
                </li>

              </ul>
            </div>
            {/* Menu End  */}
            {/* Header Right start */}
            <div className="header-right flx-align">
              {/* Light Dark Mode */}
              <ThemeToggle />
              {/* Light Dark Mode */}
              <div className="header-right__inner gap-3 flx-align d-lg-flex d-none">
                <button id="demo-button-header" onClick={() => setOpenGetDemoModal(true)} className="btn btn-orange pill">
                  <span className="icon-left icon">
                    <img src={`${assetBase}/assets/images/icons/user.svg`} alt="" />
                  </span>
                  {t('getDemo')}
                </button>
                <div className="language-select d-flex align-items-center select-has-icon gap-1">
                  <img src={`${assetBase}/assets/images/thumbs/${i18n.language}-flag.png`} alt="" className="d-block" />
                  <div className="select py-0 ps-2 border-0 fw-500">{i18n.language === 'en' ? t('language.english') : t('language.armenian')}
                    <ul>
                      <li onClick={() => handleChangeLanguage('en')}>{t('language.english')}</li>
                      <li onClick={() => handleChangeLanguage('hy')}>{t('language.armenian')}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="toggle-mobileMenu d-lg-none"
                onClick={mobileMenu}
              >
                <i className="las la-bars" />
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}

      <div className={`mobile-menu d-lg-none d-block ${active && "active"}`}>
        <button type="button" className="close-button text-body hover-text-main" onClick={mobileMenu}>
          <i className="las la-times" />
        </button>
        <div className="mobile-menu__inner">
          <Link to={getLocalizedPath(i18n.language, "/")} className="mobile-menu__logo" onClick={mobileMenu}>
            <img src={`${assetBase}/assets/images/logo/${isDarkMode ? "tamias-logo_dark" : "tamias-logo_light"}.png`} alt="Logo" />

          </Link>
          <div className="mobile-menu__menu">
            <ul
              className="nav-menu flx-align nav-menu--mobile"
              id="offcanvas-navigation"
            >
              <li className="nav-menu__item">
                <Link to={getLocalizedPath(i18n.language, "/blog")} className="nav-menu__link" onClick={mobileMenu}>
                  {t('blog')}
                  {/* activePage */}
                </Link>
              </li>
              <li className="nav-menu__item">
                <NavLink to={getLocalizedPath(i18n.language, "/contact")} className="nav-menu__link" onClick={mobileMenu}>
                  {t('contact')}
                </NavLink>
              </li>
            </ul>
            <div className="header-right__inner d-lg-none my-3 gap-1 d-flex flx-align">

              <div className="language-select d-flex align-items-center select-has-icon gap-1">
                  <img src={`${assetBase}/assets/images/thumbs/${i18n.language}-flag.png`} alt="" className="d-block" />
                  <div className="select py-0 ps-2 border-0 fw-500">{i18n.language === 'en' ? t('language.english') : t('language.armenian')}
                    <ul>
                      <li onClick={() => handleChangeLanguage('en')}>{t('language.english')}</li>
                      <li onClick={() => handleChangeLanguage('hy')}>{t('language.armenian')}</li>
                    </ul>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderOne;
